/**
 * step-fields.ts — F-003.2 Phase 1 (IMPL-P1-002).
 *
 * STEP_FIELDS mappa ogni indice di step wizard (0..4) all'array di field
 * path da passare a form.trigger() per la step-specific validation.
 *
 * Path strategy: usare i path string letterali tipizzati come
 * ReadonlyArray<string> per evitare import circolari — il tipo
 * UseFormTrigger<ContractDraft> accetta string[] senza type errors.
 *
 * Path verificati contro packages/shared/src/schemas/contract.ts
 * (contractFullBaseSchema):
 *  - locatore/conduttore: partyBaseSchema { codiceFiscale, nome, cognome,
 *    indirizzo: indirizzoSchema { via, civico, cap, comune, provincia } }
 *  - immobile: indirizzoSchema (DIRETTO — NON immobile.indirizzo.*)
 *  - catastali: datiCatastaliSchema { foglio, particella, subalterno,
 *    rendita, categoria }
 *  - top-level (da contractBaseSchema): canoneMensile, canoneAnnuale,
 *    durataMesi, tipologia, dataStipula
 *  - aggiunti da contractFullBaseSchema: regimeFiscale, ibanAdE
 */

export const STEP_FIELDS: ReadonlyArray<ReadonlyArray<string>> = [
  // Step 0 — Locatore
  [
    'locatore.codiceFiscale',
    'locatore.nome',
    'locatore.cognome',
    'locatore.indirizzo.via',
    'locatore.indirizzo.civico',
    'locatore.indirizzo.cap',
    'locatore.indirizzo.comune',
    'locatore.indirizzo.provincia',
  ],
  // Step 1 — Conduttore
  [
    'conduttore.codiceFiscale',
    'conduttore.nome',
    'conduttore.cognome',
    'conduttore.indirizzo.via',
    'conduttore.indirizzo.civico',
    'conduttore.indirizzo.cap',
    'conduttore.indirizzo.comune',
    'conduttore.indirizzo.provincia',
  ],
  // Step 2 — Immobile + Catastali
  [
    'immobile.via',
    'immobile.civico',
    'immobile.cap',
    'immobile.comune',
    'immobile.provincia',
    'catastali.foglio',
    'catastali.particella',
    'catastali.subalterno',
    'catastali.rendita',
    'catastali.categoria',
  ],
  // Step 3 — Termini economici
  [
    'tipologia',
    'durataMesi',
    'dataStipula',
    'canoneMensile',
    'canoneAnnuale',
    'regimeFiscale',
  ],
  // Step 4 — IBAN AdE
  ['ibanAdE'],
] as const;
